const List = (props) => {
  const args = {
    length: props.length,
    Item: props.Item
  }
  
  let items = [];
  for (let i = 0; i < args.length; i++) {
    items.push(<args.Item key={i} index={i} />);
  }

  return(
    <>
      { items }
    </>
  )
}

export default List;